import httpClient from '@/utilities/service/httpClient'
import AuthApi from '@/api/services/auth/AuthApi'
import DashboardApi from '@/api/services/dashboard/DashboardApi'
import SalesApi from '@/api/services/sales/SalesApi'
import FinanceApi from '@/api/services/finance/FinanceApi'
import TimesheetsApi from '@/api/services/timesheets/TimesheetsApi'
import AdjustmentApi from '@/api/services/adjustment/AdjustmentApi'
// eslint-disable-next-line prettier/prettier
import type { BidListType } from '@/api/types/response/BidListType'

export default class Api {
  apiEnd: string = '/api'

  auth(): AuthApi {
    return new AuthApi()
  }

  dashboard(): DashboardApi {
    return new DashboardApi(`${this.apiEnd}/dashboard`)
  }

  sales(): SalesApi {
    return new SalesApi(`${this.apiEnd}/sales`)
  }

  finance(): FinanceApi {
    return new FinanceApi(`${this.apiEnd}/finance/wip`)
  }

  timesheets(): TimesheetsApi {
    return new TimesheetsApi(`${this.apiEnd}/timesheets`)
  }

  fetchBidListByType(url: string): Promise<BidListType> {
    return httpClient.get(url)
  }

  adjustment(): AdjustmentApi {
    return new AdjustmentApi(`${this.apiEnd}/adjustment`)
  }
}
